import React, { useState } from "react";
import {
  Bell,
  Search,
  Settings,
  User,
  Lock,
  CreditCard,
  Shield,
  DollarSign,
  MessageSquare,
  Users,
  Mail,
  AlertCircle,
} from "lucide-react";
import { Col, Row } from "react-bootstrap";
import dotes from "../../../assets/img/dotes.svg";
import notification_message1 from "../../../assets/img/Professional Notifications.svg";
import notification_message from "../../../assets/img/Professional Notifications rounded.svg";
import views from "../../../assets/img/view dark gray blue.svg";
import finalPayment from "../../../assets/img/final payment.svg";
import ReadyToGoJobPosted from "../../../assets/img/Ready to Go job posted.svg";
import approvedContract from "../../../assets/img/approved the contract.svg";
import LeaveFeedback from "../../../assets/img/Leave feedback.svg";
import profile from "../../../assets/img/profile mssg noti.svg";
import PrivacySettings from "../../../assets/img/Privacy Settings mssg noti.svg";
import PasswordSecurity from "../../../assets/img/Password & Security mssg  noti.svg";
import Notifications from "../../../assets/img/Preferences massage noti.svg";
import PrivacyPolicy from "../../../assets/img/Privacy Policy massage noti.svg";
import filter from "../../../assets/img/Filter by Type.svg";
import payment from "../../../assets/img/payment messag noti.svg";
import Approvals from "../../../assets/img/Approvals message noti.svg";
import warnings from "../../../assets/img/Warnings message noti.svg";
import readyToDo from "../../../assets/img/Ready to Go message noti.svg";
import integrations from "../../../assets/img/Information message noti.svg";
import messages from "../../../assets/img/Messages noti.svg";
import preferences from "../../../assets/img/Preferences massage noti.svg";
import Archive from "../../../assets/img/Archive massage noti.svg";
import Clear from "../../../assets/img/Clear message noti.svg";
import logout from "../../../assets/img/logout mssg noti.svg";

const MassageNotification = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [notificationSettings, setNotificationSettings] = useState({
    payments: true,
    approvals: false,
    warnings: false,
    readyToDo: false,
    information: false,
    messages: false,
    preferences: false,
    emailNotifications: false,
    pushNotifications: false,
    soundAlerts: false,
  });

  const notifications = [
    {
      id: 1,
      icon: <img src={views} alt="view icon" />,
      text: "Your bill was viewed by Ryan G.",
      company: "3:31 PM",
      time: "12:18",
      type: "viewed",
    },
    {
      id: 2,
      icon: <img src={views} alt="view icon" />,
      text: "Your bill was approved by Ryan Smith",
      company: "3:31 PM",
      time: "10:42",
      type: "approved",
    },
    {
      id: 3,
      icon: <img src={views} alt="view icon" />,
      text: "Your bill was viewed by Dylan R.",
      company: "3:31 PM",
      time: "10:19",
      type: "viewed",
    },
    {
      id: 4,
      icon: <img src={finalPayment} alt="dollar" />,
      text: "A final payment of $3,500.00 has been made by John Carson for Stripe",
      company: "3:31 PM",
      time: "10:14",
      type: "payment",
    },
    {
      id: 5,
      icon: <img src={finalPayment} alt="dollar" />,
      text: "A deposit payment of $1,245.31 has been made by Jim Garcia via Stripe",
      company: "3:31 PM",
      time: "09:11",
      type: "payment",
    },
    {
      id: 6,
      icon: <img src={approvedContract} alt="approvedcontract" />,
      text: "John Garcia has approved the contract",
      company: "3:31 PM",
      time: "08:12",
      type: "approved",
    },
    {
      id: 7,
      icon: <img src={ReadyToGoJobPosted} alt="Ready to Go job posted" />,
      text: "There is a new Ready to Go job position in your area",
      company: "3:31 PMt",
      time: "11:59",
      type: "alert",
    },
    {
      id: 8,
      icon: <img src={LeaveFeedback} alt="Leave feedback" />,
      text: "Leave feedback to Dylan Smith for your most recent project",
      company: "3:31 PM",
      time: "10:11",
      type: "message",
    },
  ];

  const handleToggle = (setting) => {
    setNotificationSettings((prev) => ({
      ...prev,
      [setting]: !prev[setting],
    }));
  };

  const handleArchiveAll = () => {
   // //console.log("Archive all notifications");
  };

  const handleClearAll = () => {
   // //console.log("Clear all notifications");
  };

  return (
    <div className="dashboard-massage-notification">
      <div className="custom_container">
        <div className="dashboard-massage">
          <Row>
            <Col md={12}>
              <div className="panel-header">
                <div className="header-content">
                  <div className="brand">
                    <div className="brand-icon">
                      {" "}
                      <img src={notification_message1} alt="logo" />
                    </div>
                    <div className="brand-text">
                      <h2>Professional Notifications</h2>
                      <p>Always Green TurF A-Z</p>
                    </div>
                  </div>
                  <div className="settings-btn">
                    <Settings size={20} />
                  </div>
                </div>
              </div>
            </Col>

            <Col md={12} lg={8} className="pe-2 pe-lg-0">
              <div className="notifications-panel">
                <div className="notifications-content">
                  <div className="notifications-header">
                    <div>
                      <h3>Notifications</h3>
                      <span className="count">2 unread - 16 total</span>
                    </div>
                    <img
                      src={dotes}
                      alt="dotes"
                      style={{ width: "48px", height: "48px" }}
                    />
                  </div>

                  <div className="search-bar">
                    <Search size={18} />
                    <input type="text" placeholder="Search notifications..." />
                  </div>

                  <div className="filter-tabs">
                    <span className="label">Most Recent</span>
                  </div>

                  <div className="notifications-list">
                    {notifications.map((notif) => (
                      <div
                        key={notif.id}
                        className={`notification-item ${notif.type}`}
                      >
                        <div className="notif-icon">{notif.icon}</div>
                        <div className="notif-content">
                          <p className="notif-text">{notif.text}</p>
                          <div className="notif-meta">
                            <span className="company">{notif.company}</span>
                            <span className="time">{notif.time}</span>
                          </div>
                        </div>
                        <span className="arrow">›</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>

            <Col md={12} lg={4} className="ps-2 ps-lg-0">
              <div className="settings-header">
                <h3>Settings</h3>
                <p>Manage your notification preferences</p>
              </div>
              <div className="settings-panel">
                <div className="profile-section">
                  <div className="profile-avatar">
                    <img src={notification_message} alt="logo" />
                  </div>
                  <div className="profile-info">
                    <h4>Always Green TurF A-Z</h4>
                    <p>Professional Landscaping Services</p>
                  </div>
                </div>

                <div className="menu-list">
                  <button
                    className="menu-item"
                    style={{ borderRadius: "8px 8px 0 0" }}
                  >
                    <img src={profile} alt="profile" />
                    <span>Profile</span>
                    <span className="arrow">›</span>
                  </button>
                  <button className="menu-item">
                    <img src={PrivacySettings} alt="privacy settings" />
                    <span>Privacy Settings</span>
                    <span className="arrow">›</span>
                  </button>
                  <button className="menu-item">
                    <img src={PasswordSecurity} alt="Password & Security" />
                    <span>Password & Security</span>
                    <span className="arrow">›</span>
                  </button>
                  <button className="menu-item active">
                    <img src={Notifications} alt="notifications" />
                    <span>Notifications</span>
                    <label className="toggle">
                      <input type="checkbox" defaultChecked />
                      <span className="slider"></span>
                    </label>
                  </button>
                  <button className="menu-item">
                    <img src={PrivacyPolicy} alt="terms of service" />
                    <span>Terms of Service</span>
                    <span className="arrow">›</span>
                  </button>
                  <button
                    className="menu-item"
                    style={{ borderRadius: "0 0 8px 8px" }}
                  >
                    <img src={PrivacyPolicy} alt="profPrivacyPolicyile" />
                    <span>Privacy Policy</span>
                    <span className="arrow">›</span>
                  </button>
                </div>

                <div className="notification-settings">
                  <h4>Notification Settings</h4>
                  <p>Customize how you receive notifications</p>

                  <div className="settings-group">
                    <button className="group-header">
                      <img src={filter} alt="filter icon" />
                      <span>Filter by Type </span>
                    </button>

                    <div className="settings-items">
                      {[
                        {
                          key: "payments",
                          label: "Payments",
                          checked: true,
                          icon: (
                            <img src={payment} alt="payment" className="me-2" />
                          ),
                        },
                        {
                          key: "approvals",
                          label: "Approvals",
                          checked: false,
                          icon: (
                            <img
                              src={Approvals}
                              alt="Approvals"
                              className="me-2"
                            />
                          ),
                        },
                        {
                          key: "warnings",
                          label: "Warnings",
                          checked: false,
                          icon: (
                            <img
                              src={warnings}
                              alt="warnings"
                              className="me-2"
                            />
                          ),
                        },
                        {
                          key: "readyToDo",
                          label: "Ready to Do",
                          checked: false,
                          icon: (
                            <img
                              src={readyToDo}
                              alt="readyToDo"
                              className="me-2"
                            />
                          ),
                        },
                        {
                          key: "information",
                          label: "Information",
                          checked: false,
                          icon: (
                            <img
                              src={integrations}
                              alt="integrations"
                              className="me-2"
                            />
                          ),
                        },
                        {
                          key: "messages",
                          label: "Messages",
                          checked: false,
                          icon: (
                            <img
                              src={messages}
                              alt="messages"
                              className="me-2"
                            />
                          ),
                        },
                        {
                          key: "preferences",
                          label: "Preferences",
                          icon: (
                            <img
                              src={preferences}
                              alt="preferences"
                              className="me-2"
                            />
                          ),
                          className: "no-padding", // Add this
                        },
                        {
                          key: "emailNotifications",
                          label: "Email notifications",
                          checked: false,
                        },
                        {
                          key: "pushNotifications",
                          label: "Push notifications",
                          checked: false,
                        },
                        {
                          key: "soundAlerts",
                          label: "Sound alerts",
                          checked: false,
                        },
                      ].map((item) => (
                        <label
                          key={item.key}
                          className={`setting-item ${item.className || ""}`}
                        >
                          <span>
                            {item.icon}
                            {item.label}
                          </span>
                          <input
                            type="checkbox"
                            checked={notificationSettings[item.key]}
                            onChange={() => handleToggle(item.key)}
                          />
                          <span className="checkbox"></span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <span className="quickAction">Quick Actions</span>
                  <div className="action-buttons">
                    <button
                      className="btn-secondary"
                      onClick={handleArchiveAll}
                    >
                      <img src={Archive} alt="Archive" />
                      Archive All
                    </button>
                    <button className="btn-danger" onClick={handleClearAll}>
                      <img src={Clear} alt="Clear" />
                      Clear All
                    </button>
                  </div>
                </div>

                <button className="logout-btn">
                  <img src={logout} alt="logout" />
                  <span>Logout</span>
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default MassageNotification;
